import {
  ACTIONS,
  activity,
  AnalyticsEventPropTypes,
  AnalyticsEventWithControlName,
  eventDetailVersion
} from '@uma/react-commons/dist';
import {
  screenPathDeviceDetailing,
  controlDetailManageDeviceSubscription
} from 'src/utils/constants';
import { ScreenName } from 'src/utils/enums';

export const DeviceDetailsError = (
  errorInfo: string
): AnalyticsEventPropTypes => {
  return {
    actionAuxParams: `error=${errorInfo?.slice(0, 256)}`,
    action: ACTIONS.MODULE_DISPLAYED,
    activity,
    screenPath: screenPathDeviceDetailing,
    screenName: 'DeviceDetailsError',
    version: eventDetailVersion
  };
};

export const ManageDeviceSubscription = (
  deviceDetails: string
): AnalyticsEventWithControlName => {
  return {
    action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
    activity,
    screenPath: screenPathDeviceDetailing,
    screenName: ScreenName.DEVICE_DETAILS,
    screenMode: 'Printer',
    controlName: 'ManageDeviceSubscriptionLink',
    controlDetail: controlDetailManageDeviceSubscription,
    actionAuxParams: deviceDetails,
    version: eventDetailVersion
  };
};
